import React from 'react';
import { getListingTooltip } from 'utils';

const listingTooltip = getListingTooltip() || { registerTooltip: () => {} };

export default Component => props => (
    <Component {...props} registerTooltip={listingTooltip.registerTooltip} />
);
